import { lazy } from 'react';

// Depois de uma atualização, uma aba que ficou aberta ainda aponta para os
// pacotes antigos, que somem do servidor no deploy: ao abrir outra página ela
// ficaria em branco. Na primeira falha, recarrega uma vez para pegar a versão
// nova; se falhar de novo (ex.: sem internet), o erro segue normalmente.
export const CHAVE_RECARGA = 'sisagenda:recarregou-por-versao';

const ler = () => { try { return sessionStorage.getItem(CHAVE_RECARGA); } catch { return null; } };
const gravar = (v) => { try { v ? sessionStorage.setItem(CHAVE_RECARGA, v) : sessionStorage.removeItem(CHAVE_RECARGA); } catch { /* sem sessionStorage */ } };

export function carregarComRecarga(importar, recarregar = () => window.location.reload()) {
  return importar()
    .then((modulo) => { gravar(null); return modulo; })
    .catch((erro) => {
      if (ler() === '1') { gravar(null); throw erro; }
      gravar('1');
      recarregar();
      return new Promise(() => {}); // espera a página recarregar
    });
}

const lazyComRecarga = (importar) => lazy(() => carregarComRecarga(importar));
export default lazyComRecarga;
